import React from 'react';
import { CopyBlock, dracula } from 'react-code-blocks';

const JSXCode = ({ code = '' }) => {
  return (
    <CopyBlock
      language={'jsx'}
      text={code}
      showLineNumbers={true}
      theme={dracula}
      wrapLines={true}
      codeBlock
    />
  );
};

export default JSXCode;
